import * as allActions from "../../actions/actions.constants";

const initialState = {
  isAuthorized: false,
  userDetails: {},
  landApiData: {},
  errorMessage: "",
  isloading: false,
  SignInCheckData: {},
  authorizedStatus: {},
  isLogout: false,
  isNewUser: false,
  isAuthenticating: false,
};

const SignInReducer = (state = initialState, action) => {
  switch (action.type) {
    case allActions.DO_SIGNIN:
      return action;
    case allActions.RECEIVE_SIGN_IN_DATA:
      return {
        ...state,
        SignInCheckData: action.payload,
      };
    case allActions.SET_AUTHENTICATING:
      return { ...state, isAuthenticating: action.payload };
    case allActions.AUTHORIZED_USER:
      return {
        ...state,
        isAuthorized: true,
        isLogout: false,
      };
    case allActions.RECIEVE_SIGNIN_STATUS:
      return {
        ...state,
        userDetails: action.payload,
      };
    case allActions.RECEIVE_LAND_API_DATA:
      return {
        ...state,
        landApiData: action.payload,
      };
    case allActions.UNAUTHORIZED_USER:
      return {
        ...state,
        isAuthorized: false,
        errorMessage: "Incorrect Email or Password",
      };
    case allActions.NEW_USER:
      return {
        ...state,
        isAuthorized: false,
        errorMessage: "You don't seem to have an account!",
      };
    case allActions.LOADING_VALUE:
      return {
        ...state,
        isloading: true,
      };
    case allActions.LOADING_VALUE_STOP:
      return {
        ...state,
        isloading: false,
      };
    case allActions.RESET_MODERATOR_COUNT:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          userData: {
            ...state.userDetails.userData,
            moderatorActionItemsViewStatus: 0, // reset count
          },
        },
      };
    case allActions.RESET_NOTIFICATION_COUNT:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          userData: {
            ...state.userDetails.userData,
            notificatinCount: 0, // reset count
          },
        },
      };
    case allActions.UPDATE_IS_NEW_USER:
      return {
        ...state,
        isNewUser: action.payload,
      };
    // case allActions.SiGNoUT_STATUS:
    //   return action;
    case allActions.SIGNOUT:
      return {
        ...state,
        isAuthorized: false,
        isLogout: true,
      };
    default:
      return state;
  }
};
export default SignInReducer;
